<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && oferta">
      <px-oferta-title :oferta="oferta"/>
      <v-row>
        <v-col cols="12" sm="7">
          <px-oferta-foto :oferta="oferta"/>
        </v-col>
        <v-col cols="12" sm="5">
          <px-oferta-info-preco :oferta="oferta"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <px-oferta-especificacao :oferta="oferta"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <px-oferta-duvidas :oferta="oferta"/>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import OfertaService from '../oferta-service';
import OfertaTitle from './OfertaTitle.vue';
import OfertaFoto from './OfertaFoto.vue';
import OfertaInfoPreco from './OfertaInfoPreco.vue';
import OfertaEspecificacao from './OfertaEspecificacao.vue';
import OfertaDuvidas from './OfertaDuvidas.vue';

export default {
  data() {
    return {
      loading: false,
      oferta: null,
      id: this.$route.params.id,
    };
  },
  methods: {
    getOferta() {
      this.loading = true;
      OfertaService.get(this.id)
        .then(({ data }) => {
          this.oferta = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getOferta();
  },
  components: {
    pxOfertaTitle: OfertaTitle,
    pxOfertaFoto: OfertaFoto,
    pxOfertaInfoPreco: OfertaInfoPreco,
    pxOfertaEspecificacao: OfertaEspecificacao,
    pxOfertaDuvidas: OfertaDuvidas,
  },
};
</script>
